//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import { mdiCopyright } from '@mdi/js'
import Countdown from '~/components/global/Countdown.vue'

export default {
  name: 'Login',
  components: { Countdown },
  layout: 'login',
  middleware: ['notLogged'],
  data: () => {
    return {
      endDate: undefined,
      icons: {
        mdiCopyright,
      },
      isLoading: false,
      valid: true,
      loginDetails: {
        Email: '',
        Password: '',
      },
      globalError: '' || null,
      formErrors: {} || null,
      showRepeatPassword: false,
      pageLoaded: false,
    }
  },
  head() {
    return {
      title: 'BluLog console - login',
      htmlAttrs: {
        lang: 'en',
      },
    }
  },
  computed: {
    ...mapGetters(['isInMaintenanceMode']),
    ...mapState(['maintenanceEndDate']),
    organizationLogo() {
      return this.$store.state.localStorage.userData?.Personalization?.Logo
    },
  },
  created() {
    this.endDate = this.$moment
      .utc(this.maintenanceEndDate)
      .local()
      .format('YYYY-MM-DD HH:mm:ss')
  },
  methods: {
    validate() {
      return (this.valid = this.$refs.loginForm.validate())
    },
    resetValidation() {
      this.globalError = '' || null
      this.formErrors = {} || null
      this.$refs.loginForm.resetValidation()
    },
    async signIn() {
      if (!this.validate()) {
        return false
      }
      this.resetValidation()
      this.isLoading = true

      const $this = this
      await this.$axios
        .$post('/login/', this.loginDetails)
        .then((resp) => {
          localStorage.setItem('logged', '1')
          this.$setUserData(resp.Result.UserData)

          if (resp.Result.UserData.PasswordExpiresIn) {
            localStorage.setItem(
              'passwordExpiresIn',
              resp.Result.UserData.PasswordExpiresIn
            )
          }

          const objectID =
            resp.Result.UserData.DisplayedObjectGraphAtStartPageID
          if (objectID === 0) {
            return $this.$router.push('/measurements/')
          } else {
            return $this.$router.push('/objects/details/?view&id=' + objectID)
          }
        })
        .catch((error) => {
          if (!error.response) {
            return error
          }
          if (error.response.data.FieldsError) {
            if (error.response.data.FieldsError.PasswordExpired) {
              return this.sendEmailChangePassword()
            } else {
              $this.formErrors = error.response.data.FieldsError
            }
          }

          if (error.response.data.GlobalError) {
            this.globalError = error.response.data.GlobalError
          }
        })
        .then(() => {
          this.isLoading = false
        })
      return false
    },
    sendEmailChangePassword() {
      this.$axios
        .$post('/change-password/', {
          Email: this.loginDetails.Email,
        })
        .then(() => {
          return this.$router.push('/password-expired/')
        })
        .catch((error) => {
          if (!error.response) {
            return error
          }
          if (error.response.data.GlobalError) {
            this.globalError = error.response.data.GlobalError
          }
        })
    },
  },
}
